import React, { useEffect, useState } from 'react';

const Cursor = () => {
  const [mousePosition, setMousePosition] = useState(() => {
    if (typeof window === 'undefined') return { x: 0, y: 0 };
    return window.__tobstarCursorPos || { x: 0, y: 0 };
  });


  const fullCursorSize = 46; // Include the fullCursorSize variable
 

  useEffect(() => {
    const handleMouseMove = (e) => {
      const pos = { x: e.clientX, y: e.clientY };
      if (typeof window !== 'undefined') window.__tobstarCursorPos = pos;
      setMousePosition(pos);
    };

    const handlePointerDown = (e) => {
      const pos = { x: e.clientX, y: e.clientY };
      if (typeof window !== 'undefined') window.__tobstarCursorPos = pos;
      setMousePosition(pos);

      const cursor = document.querySelector('.cursor');
      if (!cursor) return;
      cursor.classList.remove('read_article', 'view_project', 'back_home', 'back_top');

      cursor.style.backgroundColor = "";
      cursor.style.width = "";
      cursor.style.height = "";
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('pointerdown', handlePointerDown, true);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('pointerdown', handlePointerDown, true);
    };
  }, []);



  useEffect(() => {
    const enlargeCursor = () => {
      const cursor = document.querySelector(".cursor");
      if (!cursor) return;
      cursor.style.backgroundColor = "rgb(255, 165, 0, 0.4)";
      cursor.style.width = `${fullCursorSize}px`;
      cursor.style.height = `${fullCursorSize}px`;
    };

    const shrinkCursor = () => {
      const cursor = document.querySelector(".cursor");
      if (!cursor) return;
      cursor.style.backgroundColor = ""; // Revert to default
      cursor.style.width = "";
      cursor.style.height = "";
    };

    const handleCursorEnter = () => {
      enlargeCursor();
    };

    const handleCursorLeave = () => {
      shrinkCursor();
    };

    const selector = "a, button, .close, .owl-next, .owl-prev, .goUp i, .next i, .prev i";

    const onMouseOver = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest(selector)) handleCursorEnter();
    };

    const onMouseOut = (event) => {
      const from = event.target;
      const to = event.relatedTarget;
      if (!(from instanceof Element)) return;
      if (to instanceof Element && to.closest(selector)) return;
      if (from.closest(selector)) handleCursorLeave();
    };

    document.addEventListener("mouseover", onMouseOver, true);
    document.addEventListener("mouseout", onMouseOut, true);

    return () => {
      document.removeEventListener("mouseover", onMouseOver, true);
      document.removeEventListener("mouseout", onMouseOut, true);
    };
  }, [fullCursorSize]); // Added dependency

  return (
    <>
    <div className="cursor-wrapper" style={{ transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)` }}>
      <div className="cursor" />
    </div>
    </>
  );
};

export default Cursor;
